export const environment = {
  production: false,
  apiUrl: 'https://dev.comparamotors.com',
  socketUrl: 'https://dev.comparamotors.com',
  version: '1.0.0',
  appName: 'Comparamotors frontend',
  supportEmail: '',
  gtmId: 'GTM-WHNLQ4MG'
};
